export enum Category {
  UNKNOWN,
  ASLEEP,
  AWAKE,
  PUT_DOWN,
}
